import { BASE_URL } from "../../api/config";
import { EndpointsE } from "../../data/endpoints";
import { blobToBase64 } from "./blobToBase64";
import authenticatedFetch from "./auth/authenticatedFetch";

export const fetchBase64ProfilePhoto = async (
  id: string | number,
  outerToken?: string
) => {
  try {
    const url = BASE_URL + EndpointsE.CLIENTS_GET_LOGO_IMAGE + id;
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    };

    const imgRes = outerToken
      ? await fetch(url, {
          headers: {
            ...headers,
            authorization: `Bearer ${outerToken}`,
          },
        })
      : await authenticatedFetch(url, { headers });

    const imageBlob = await imgRes.blob();
    const imgBase64 = await blobToBase64(imageBlob);

    return imgBase64;
  } catch (e: any) {
    console.log(e);
  }
};

export const fetchBase64Image = async (link: string, outerToken?: string) => {
  try {
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    };

    const imgRes = outerToken
      ? await fetch(link, {
          headers: {
            ...headers,
            authorization: `Bearer ${outerToken}`,
          },
        })
      : await authenticatedFetch(link, { headers });

    const imageBlob = await imgRes.blob();
    const imgBase64 = await blobToBase64(imageBlob);

    return imgBase64;
  } catch (e: any) {
    console.log(e);
  }
};
